import { useEffect, useRef, useState } from 'react';
import { LOGOUT_URL } from '../auth';
import { NavLink } from '../navigation';
import { initialsFromName } from '../utils';

export function AppHeader({ user, currentPath, onHelp, onShortcuts }) {
  const onFormPage = currentPath !== '/register';
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;

    function onPointerDown(event) {
      if (!menuRef.current?.contains(event.target)) {
        setMenuOpen(false);
      }
    }

    function onKeyDown(event) {
      if (event.key === 'Escape') {
        setMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="header-row">
        <div>
          <h1>PAC IT Asset Portal</h1>
          <p>
            {onFormPage
              ? 'Check In & Check Out Company Assets'
              : 'Browse and search the SharePoint asset register'}
          </p>
        </div>
        <div className="user-menu" ref={menuRef}>
          <button
            type="button"
            className={`user-chip${menuOpen ? ' is-open' : ''}`}
            onClick={() => setMenuOpen((open) => !open)}
            aria-expanded={menuOpen}
            aria-haspopup="menu"
            aria-label={`Account menu for ${user.userDetails || 'User'}`}
          >
            <div className="user-avatar">{initialsFromName(user.userDetails)}</div>
            <div className="user-name">{user.userDetails || 'User'}</div>
            <span className="user-menu-caret" aria-hidden="true" />
          </button>
          {menuOpen && (
            <div className="user-menu-panel" role="menu">
              <button
                type="button"
                role="menuitem"
                className="user-menu-item"
                title="Keyboard Shortcuts (?)"
                onClick={() => {
                  closeMenu();
                  onShortcuts();
                }}
              >
                Shortcuts
              </button>
              <button
                type="button"
                role="menuitem"
                className="user-menu-item"
                title="Help & Guide"
                onClick={() => {
                  closeMenu();
                  onHelp();
                }}
              >
                Help
              </button>
              <button
                type="button"
                role="menuitem"
                className="user-menu-item"
                title="Sign Out"
                onClick={() => {
                  window.location.href = LOGOUT_URL;
                }}
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="header-nav">
        <nav className="nav-tabs" aria-label="Portal pages">
          <NavLink
            to="/"
            className={`nav-tab${onFormPage ? ' is-active' : ''}`}
            aria-current={onFormPage ? 'page' : undefined}
          >
            Check In / Out
          </NavLink>
          <NavLink
            to="/register"
            className={`nav-tab${!onFormPage ? ' is-active' : ''}`}
            aria-current={!onFormPage ? 'page' : undefined}
          >
            Asset Register
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
